import { PICKUP_TYPE as PICKUP_TYPE_FIELD } from ".";
import { ALL } from "../strings";
import { PICKUP_PLAN_TYPE } from "../planTypes";

const DEFAULT_VALUE = {
  value: "0",
  label: ALL,
  functionParameters: { value: "0", label: ALL },
};

export const PICKUP_TYPE = {
  title: "Pickup Type",
  field: PICKUP_TYPE_FIELD,
  mapToValues: (partnerTypes) => [
    DEFAULT_VALUE,
    ...Object.values(
      (partnerTypes || []).reduce((acc, { kind, kindName }) => {
        const value = {
          value: kind,
          label: kindName,
        };
        if (!acc[kind])
          acc[kind] = {
            ...value,
            functionParameters: value,
          };

        return acc;
      }, {})
    ),
    ...Object.values(
      (partnerTypes || []).reduce(
        (acc, { partnerType, partnerName, allocateByType }) => {
          const value = {
            value: partnerType,
            label: partnerName,
          };
          if (allocateByType)
            acc[partnerType] = {
              ...value,
              functionParameters: value,
            };

          return acc;
        },
        {}
      )
    ),
  ],
  defaultValue: DEFAULT_VALUE,
  filterCallback: ({ route, pickupTypes, value }) =>
    value === DEFAULT_VALUE.value ||
    (pickupTypes[route.routeCode] || {})[value],
  volumeOverlayRequired: false,
  planTypeRequired: PICKUP_PLAN_TYPE,
};
